export const blockIconsSocialPrecisionManufacturing = (
	<span className='material-symbols-outlined'>precision_manufacturing</span>
);
